import { render } from "./CIS-Blockquote-Carousel.vue?vue&type=template&id=eb8aa3da&scoped=true"
import script from "./CIS-Blockquote-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-Blockquote-Carousel.vue?vue&type=script&lang=js"

import "./CIS-Blockquote-Carousel.vue?vue&type=style&index=0&id=eb8aa3da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8aa3da"]])

export default __exports__